<template>
  <div class="page_main">
    <div class="top_base_info">
      <div class="base_list">
        <div class="base_info">
          <img class="icon" src="@/assets/image/b1.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">维保电梯数</div>
            <div class="num">
              <div class="text">{{ formData.wbNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b2.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">物联网电梯数</div>
            <div class="num">
              <div class="text">{{ formData.iotElevators }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b3.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">物联网覆盖率</div>
            <div class="num">
              <div class="text">
                {{
                  (
                    (computedForm.iotElevators / computedForm.totalElevators) *
                    100
                  ).toFixed(2)
                }}<span>%</span>
              </div>
              <span>%</span>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b4.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">物联网在线率</div>
            <div class="num">
              <div class="text">
                {{
                  ((formData.onlineElevators / formData.iotElevators) * 100).toFixed(2)
                }}
              </div>
              <span>%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="base_list">
        <div class="base_info">
          <img class="icon" src="@/assets/image/b5.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">本月告警次数</div>
            <div class="num">
              <div class="text">{{ formData.monthAlarmNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b6.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">本月已解决</div>
            <div class="num">
              <div class="text">{{ formData.monthSolveNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b7.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">今日告警次数</div>
            <div class="num">
              <div class="text">{{ formData.dayAlarmNo }}</div>
            </div>
          </div>
        </div>
        <img class="line" src="@/assets/image/base_line.png" alt="" />
        <div class="base_info">
          <img class="icon" src="@/assets/image/b8.png" />
          <img class="arr" src="@/assets/image/marr.png" />
          <div class="info">
            <div class="label">今日已解决</div>
            <div class="num">
              <div class="text">{{ formData.daySolveNo }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_content_box">
      <div class="left">
        <div class="failure_rate item_box">
          <div class="item_title_box">故障率</div>
          <div class="failure_rate_content">
            <div class="failure_rate_charts" id="failure_rate"></div>
            <div class="failure_rate_legend">
              <div class="legend_list">
                <img class="icon" src="@/assets/image/l1.png" alt="" />
                <img class="line" src="@/assets/image/line1.png" alt="" />
                <div class="value_box">
                  <div class="status">
                    <img class="arrow" src="@/assets/image/ar1.png" alt="" />
                    无故障电梯
                  </div>
                  <div class="value">{{ formData.notFaultNo }}</div>
                </div>
              </div>
              <div class="legend_list">
                <img class="icon" src="@/assets/image/l4.png" alt="" />
                <img class="line" src="@/assets/image/line4.png" alt="" />
                <div class="value_box">
                  <div class="status warn">
                    <img class="arrow" src="@/assets/image/ar4.png" alt="" />
                    物联网电梯
                  </div>
                  <div class="value">{{ formData.iotElevators }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="failure_five_box item_box">
          <div class="item_title_box">近30天故障电梯TOP5</div>
          <div class="five_box">
            <div class="five_head">
              <div class="sort">序号</div>
              <div class="name">项目名称</div>
              <div class="code">地址</div>
              <div class="time">故障次数</div>
            </div>
            <div class="five_list_box">
              <div class="swiper-wrapper">
                <div
                  class="five_list swiper-slide"
                  v-for="(item, index) in unitElevatorListVos"
                  :key="index"
                >
                  <div class="five_container">
                    <div class="sort">
                      <div
                        class="num"
                        :class="{ one: index == 0, two: index == 1, three: index == 2 }"
                      >
                        {{ index + 1 }}
                      </div>
                    </div>
                    <div class="name text">{{ item.faultType }}</div>
                    <div class="code text">{{ item.registrationCode }}</div>
                    <div class="time text">{{ item.count }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center item_box">
        <div class="item_title_box other">
          电梯监控
          <div class="tags_box">
            <div class="tips_view success">
              <img class="icon" src="@/assets/image/c1.png" alt="" />
              物联在线：{{ formData.onlineElevators }}
            </div>
            <div class="tips_view">
              <img class="icon" src="@/assets/image/c2.png" alt="" />
              物联离线/未安装：{{ formData.offlineElevators }}
            </div>
            <div class="tips_view warn">
              <img class="icon" src="@/assets/image/c3.png" alt="" />
              检修：{{ formData.serviceNo }}
            </div>
            <div class="tips_view danger">
              <img class="icon" src="@/assets/image/c4.png" alt="" />
              故障：{{ formData.faultNumber }}
            </div>
            <div class="tips_view primary">
              <img class="icon" src="@/assets/image/c5.png" alt="" />
              摄像头：{{ formData.videoNo }}
            </div>
          </div>
        </div>
        <div class="ele_box">
          <!-- <div class="ele_list" v-for="(item, index) in 50" :key="index"> -->
          <div class="ele_list" v-for="(item, index) in elevatorVideoVos" :key="index">
            <div class="ele_content">
              <img class="ele_photo" src="@/assets/image/ele_icon.png" alt="" />
              <div class="name">{{ item.elevatorName }}</div>
              <div class="order">{{ item.proveNumber }}</div>

              <div class="ele_tag">
                <img
                  class="tag_icon"
                  v-if="item.onlineType == 1"
                  src="@/assets/image/c1.png"
                />
                <img class="tag_icon" v-else src="@/assets/image/c2.png" />
                <img
                  class="tag_icon"
                  v-if="item.serviceType == 1"
                  src="@/assets/image/c3.png"
                />
                <img
                  class="tag_icon"
                  v-if="item.faultType == 1"
                  src="@/assets/image/c4.png"
                />
                <img class="tag_icon" src="@/assets/image/c5.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="trend_box item_box">
          <div class="item_title_box">告警趋势</div>
          <div class="trend_charts" id="trend"></div>
        </div>
        <div class="real_warn_box item_box">
          <div class="item_title_box">实时告警</div>
          <div class="real_content_box">
            <!-- <div class="real_list" v-for="(item, index) in 2" :key="index"> -->
            <div class="real_list" v-for="(item, index) in realWarnList" :key="index">
              <div class="real_label">
                <div class="label">{{ item.minorTypeName }}</div>
                <div class="tag" v-if="item.status == 1">未解决</div>
              </div>
              <div class="info_box">
                <div class="info_list">
                  最新告警时间：<span>{{ item.beginTime }}</span>
                </div>
                <div class="info_list">
                  注册代码：<span>{{ item.registrationCode }}</span>
                </div>
                <div class="info_list">
                  维保单位：<span>{{ item.wbDeptName }}</span>
                </div>
                <div class="info_list">
                  所属小区：<span>{{ item.communityName }}</span>
                </div>
              </div>
              <div class="picture_box">
                <div class="title">抓拍照片：</div>
                <div class="photo_list">
                  <img class="photo" :src="item.warnPic" alt="" />
                  <img class="photo" :src="item.snapPic" alt="" />
                </div>
              </div>
            </div>
            <img
              v-if="realWarnList.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt=""
            />
            <!-- <div class="real_list">
              <div class="real_label">
                <div class="label">非平层停梯</div>
                <div class="tag">未解决</div>
              </div>
              <div class="info_box">
                <div class="info_list">
                  最新告警时间：<span>2025-05-07 18:20:13</span>
                </div>
                <div class="info_list">单位内编号：<span>C11#楼4#客</span></div>
                <div class="info_list">项目名称：<span>软件新城2.3期-1</span></div>
                <div class="info_list">
                  使用单位：<span>武汉智园科技运营有限公司</span>
                </div>
              </div>
              <div class="picture_box">
                <div class="title">抓拍照片：</div>
                <div class="photo_list">
                  <img class="photo" src="@/assets/zhuapai.png" alt="" />
                  <img class="photo" src="@/assets/zhuapai.png" alt="" />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";
import { monitiorCenter, getDataCenter } from "@/api/user";
export default {
  name: "MonitorCenter",
  components: {},
  data() {
    return {
      formData: {},
      unitElevatorListVos: [],
      homeUpkeepListVos: [],
      elevatorVideoVos: [],
      url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      webSocket: null,
      realWarnList: [],
      computedForm: {},
    };
  },

  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      console.log("App.vue 中获取的 token:", code);
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      console.log("App.vue 中获取的 token:", token);
      localStorage.setItem("token", token); // 或存到 Vuex
    }

    this.$nextTick(() => {
      this.getData();
      this.join();
    });
  },
  destroyed() {
    this.exit();
  },
  methods: {
    join() {
      const wsuri = this.url;
      let that = this;
      this.webSocket = new WebSocket(wsuri);
      this.webSocket.onopen = function (event) {
        console.log("连接成功");
        that.text_content = that.text_content + "已经打开连接!" + "\n";
      };
      this.webSocket.onmessage = function (event) {
        if (that.first) {
          that.send();
          that.first = false;
        }
        //接收消息
        console.log("接收消息", event);
        that.text_content = event.data + "\n";
        //接收消息处理

        if (event.data !== "连接成功" && event.data !== "heart") {
          console.log(JSON.parse(event.data), "event.dataevent.data");

          that.realWarnList.push(JSON.parse(event.data));
          if (that.realWarnList.length > 2) {
            that.realWarnList.shift(); // 移除最前面的元素，保持最多两个
          }
          setInterval(() => {
            that.send();
          }, 10000);
        }
      };
      this.webSocket.onerror = function (error) {
        console.error("WebSocket 出错", error);
        that.join();
      };
      this.webSocket.onclose = function (event) {
        that.text_content = that.text_content + "已经关闭连接!" + "\n";
      };
    },
    exit() {
      if (this.webSocket) {
        this.webSocket.close();
        this.webSocket = null;
      }
    },
    send() {
      if (this.webSocket) {
        this.webSocket.send(localStorage.getItem("token"));
      } else {
        // alert("未连接到服务器");
      }
    },
    getData() {
      monitiorCenter().then((res) => {
        this.formData = res.data;
        this.homeUpkeepListVos = res.data?.homeUpkeepListVos;
        this.elevatorVideoVos = res.data?.elevatorVideoVos;
        this.unitElevatorListVos = res.data?.unitElevatorListVos;

        this.$nextTick(() => {
          this.initFailureRate();
          this.initWarnTrend();
          this.swiperInitFive();
        });
      });
      getDataCenter().then((res) => {
        this.computedForm = res.data;
      });
    },
    initWarnTrend() {
      const charts = echarts.init(document.getElementById("trend"));
      const option = {
        backgroundColor: "#001f2d", // 或者设置为背景图
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["总告警次数", "处理告警数"],
          top: 10,
          right: 20,
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "20",
          right: "30",
          bottom: "10",
          top: "45",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.homeUpkeepListVos.map((item) => {
            return item.dateDay;
          }),
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          name: "单位: 次",
          nameTextStyle: {
            color: "#fff",
            padding: [0, 0, 0, -10],
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            color: "#fff",
          },
          splitLine: {
            lineStyle: {
              color: "#274d68",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "总告警次数", //蓝色线
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              color: "#FFB300",
            },
            lineStyle: {
              color: "#FFB300",
              width: 3,
            },
            data: this.homeUpkeepListVos.map((item) => {
              return item.upkeepNumber;
            }),
          },
          {
            name: "处理告警数", //橙色线
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              color: "#00E3E3",
            },
            lineStyle: {
              color: "#00E3E3",
              width: 3,
            },
            data: this.homeUpkeepListVos.map((item) => {
              return item.doneNumber;
            }),
          },
        ],
      };
      charts.setOption(option);
    },

    initFailureRate() {
      const charts = echarts.init(document.getElementById("failure_rate"));
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            if (params.name === "fault") {
              return `无故障电梯：${this.formData.notFaultNo}`;
            } else {
              return `物联网电梯：${this.formData.iotElevators}`;
            }
          },
        },
        series: [
          {
            name: "故障率",
            type: "pie",
            radius: ["70%", "85%"],
            avoidLabelOverlap: true,
            label: { show: false },
            labelLine: { show: false },
            data: [
              {
                value: this.formData.notFaultNo,
                name: "fault",
                itemStyle: { color: "#00CC66" },
              },
              {
                value: this.formData.iotElevators,
                name: "normal",
                itemStyle: { color: "#3399FF" },
              },
            ],
          },
        ],
      };
      charts.setOption(option);
    },

    swiperInitFive() {
      new Swiper(".five_list_box", {
        slidesPerView: "5",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page_main {
  // width: 1720px;
  // height: 1032px;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .top_base_info {
    width: 100%;
    height: 134px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .base_list {
      width: calc(50% - 10px);
      height: 100%;
      background: url("@/assets/image/base_bg.png") no-repeat center;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .base_info {
        height: 54px;
        display: flex;
        align-items: flex-start;
        .icon {
          width: 76px;
          height: 54px;
        }
        .arr {
          margin: 0 10px;
          height: 12px;
          width: 14px;
        }
        .info {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .label {
            font-weight: 700;
            font-size: 14px;
            color: #fff;
          }
          .num {
            display: flex;
            align-items: center;
            .text {
              font-family: D-DIN;
              font-weight: 700;
              line-height: 28px;
              font-size: 28px;
              background: linear-gradient(90deg, #00fffd 0%, #0095fa 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            span {
              font-weight: 700;
              font-size: 12px;
              color: #fff;
              margin-top: 15px;
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 40px;
      }
    }
  }
  .bottom_content_box {
    height: calc(100% - 149px);
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left {
      height: 100%;
      width: 480px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .failure_rate {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: calc(100% - 457px);
        .failure_rate_content {
          background: url("@/assets/image/g1.png") no-repeat center;
          background-size: 100% 100%;
          height: 240px;
          padding: 15px 20px;
          width: 440px;
          display: flex;
          align-items: center;
          .failure_rate_charts {
            width: 50%;
            height: 100%;
          }
          .failure_rate_legend {
            width: 50%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-evenly;
            .legend_list {
              height: 48px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 100%;
              .icon {
                width: 66px;
                height: 48px;
              }
              .line {
                height: 40px;
                width: 1px;
                margin: auto 20px;
              }
              .value_box {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                .status {
                  display: flex;
                  align-items: center;
                  font-weight: 400;
                  font-size: 14px;
                  color: #00cb61;
                  .arrow {
                    margin-right: 10px;
                    width: 14px;
                    height: 12px;
                  }
                  &.warn {
                    color: #e2b400;
                  }
                  &.danger {
                    color: #d01c00;
                  }
                }
                .value {
                  width: 25px;
                  height: 26px;
                  font-family: D-DIN;
                  font-weight: 700;
                  font-size: 24px;
                  color: #fff;
                  line-height: 26px;
                }
              }
            }
          }
        }
      }
      .failure_five_box {
        height: 442px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .five_box {
          height: 370px;
          width: 100%;
          padding: 20px 0 10px;
          background: url("@/assets/image/five_bg.png") no-repeat center;
          background-size: 100% 100%;
          margin: auto;
          .five_head {
            width: 460px;
            margin: auto;
            height: 100%;
            display: flex;
            align-items: center;
            height: 46px;
            background: #0563b0;
            div {
              text-align: center;
              font-weight: 400;
              font-size: 14px;
              color: #fff;
            }
          }
          .five_list_box {
            height: calc(100% - 61px);
            overflow: hidden;
            margin: 10px auto 0;
            width: 460px;
            .five_list {
              width: 100%;
              height: 60px;

              .five_container {
                background: rgba(8, 85, 150, 0.29);
                display: flex;
                align-items: center;
                height: 50px;
                .text {
                  font-weight: 400;
                  font-size: 14px;
                  color: #fff;
                  line-height: 18px;
                  text-align: center;
                }
              }
              .num {
                width: 24px;
                height: 24px;
                margin: auto;
                line-height: 24px;
                text-align: center;
                font-weight: 700;
                font-size: 14px;
                color: #fff;
                background: linear-gradient(180deg, #74c2c0 0%, #559090 100%);

                &.one {
                  background: linear-gradient(180deg, #ff9d60 0%, #ff5900 100%);
                }
                &.two {
                  background: linear-gradient(180deg, #ffdb4f 0%, #bf9800 100%);
                }
                &.three {
                  background: linear-gradient(180deg, #546ce7 0%, #2645c1 100%);
                }
              }
            }
          }
          .sort {
            width: 15%;
          }
          .name {
            width: 30%;
          }
          .code {
            width: 35%;
          }
          .time {
            width: 20%;
          }
        }
      }
    }
    .center {
      width: calc(100% - 990px);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .ele_box {
        height: calc(100% - 82px);
        padding: 20px 0;
        background: url("@/assets/image/center_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        overflow-y: auto;
        .ele_list {
          width: calc(100% / 3);
          // width: 25%;
          height: 195px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          box-sizing: border-box;
          .ele_content {
            width: 90%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            background: url("@/assets/image/ele_bg.png") no-repeat center;
            background-size: 100% 100%;
            position: relative;
            .ele_tag {
              position: absolute;
              margin: auto;
              left: 0;
              top: 0;
              bottom: 0;
              width: 35px;
              padding-top: 15px;
              display: flex;
              flex-direction: column;
              align-items: center;
              .tag_icon {
                margin-bottom: 10px;
                width: 14px;
                height: 14px;
              }
            }
            .ele_photo {
              width: 100px;
              height: 100px;
            }
            .name {
              font-weight: 400;
              font-size: 12px;
              color: #fff;
            }
            .order {
              font-weight: 400;
              font-size: 12px;
              color: #fff;
            }
          }
        }
      }
    }
    .right {
      height: 100%;
      width: 480px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .trend_box {
        height: calc(100% - 417px);
        width: 100%;
        .trend_charts {
          background: url("@/assets/image/rate_bg.png") no-repeat center;
          background-size: 100% 100%;
          height: calc(100% - 42px);
        }
      }
      .real_warn_box {
        height: 402px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .real_content_box {
          width: calc(100% - 20px);
          height: 360px;
          padding: 20px 10px;
          background: url("@/assets/image/five_bg.png") no-repeat center;
          background-size: 100% 100%;
          display: flex;
          justify-content: space-between;
          .real_list {
            height: calc(100% - 20px);
            width: 205px;
            background: rgba(8, 85, 150, 0.29);
            padding: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            .real_label {
              width: calc(100% - 20px);
              height: 46px;
              background: linear-gradient(180deg, #4c9fe4 0%, #0563b0 100%);
              padding: 0 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              .label {
                font-weight: 700;
                font-size: 14px;
                color: #fff;
              }
              .tag {
                background: url("@/assets/image/warn_icon.png") no-repeat center;
                background-size: 100% 100%;
                width: 62px;
                height: 24px;
                font-weight: 700;
                font-size: 12px;
                color: #fff;
                text-align: center;
                line-height: 24px;
              }
            }
            .info_box {
              .info_list {
                font-weight: 400;
                font-size: 12px;
                color: #b8c6d3;
                text-align: left;
                line-height: 30px;
                span {
                  font-size: 12px;
                  color: #fff;
                }
              }
            }
            .picture_box {
              width: 100%;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              margin-bottom: 20px;
              .title {
                font-weight: 400;
                font-size: 12px;
                color: #b8c6d3;
              }
              .photo_list {
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
                .photo {
                  width: 96px;
                  height: 72px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.item_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  .item_title_box {
    width: calc(100% - 40px);
    height: 36px;
    background: url("@/assets/image/box_title_bg.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: 6px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 24px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 40px;
    &.other {
      background: url("@/assets/image/center_title_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .tags_box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .tips_view {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #d6cfcd;
        font-family: Microsoft YaHei;
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        &.success {
          color: #34fa93;
        }
        &.warn {
          color: #fca30a;
        }
        &.danger {
          color: #ed4c33;
        }
        &.primary {
          color: #00eeff;
        }
      }
    }
  }
}
.nothing {
  width: 40%;
  margin: auto;
}
.ele_box::-webkit-scrollbar {
  display: none; /* Chrome / Safari / Edge */
}
</style>
